export const getDataBreachRiskStatus = (columns) => {
  if (!columns || !Array.isArray(columns)) {
    return { status: "unknown", label: "Unknown", color: "gray" };
  }

  const highRiskColumns = ["password"];
  const mediumRiskColumns = ["name", "surname", "address", "phone"];
  const lowRiskColumns = ["username", "email"];

  if (columns.some((col) => highRiskColumns.includes(col))) {
    return { status: "high", label: "high_risk", color: "red" };
  }

  if (columns.some((col) => mediumRiskColumns.includes(col))) {
    return { status: "medium", label: "medium_risk", color: "orange" };
  }

  if (columns.some((col) => lowRiskColumns.includes(col))) {
    return { status: "low", label: "low_risk", color: "#FFD700" }; // Yellow
  }

  return { status: "unknown", label: "Unknown", color: "gray" };
};

export const getDataBreachRiskExplanation = (riskLevel, columns) => {
  if (!columns || !Array.isArray(columns)) {
    return "Unknown risk level";
  }

  switch (riskLevel.status) {
    case "high":
      return "High risk due to compromised passwords which could lead to account takeovers.";
    case "medium":
      const mediumRiskColumns = columns.filter((col) =>
        ["name", "surname", "address", "phone"].includes(col)
      );
      return `Medium risk due to exposed personal information (${mediumRiskColumns.join(", ")}), which could be used for identity fraud.`;
    case "low":
      return "Low risk exposure of email/username only, which could lead to spam or phishing attempts.";
    default:
      return "Unknown risk level";
  }
};
